function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M1.7 20.24c.01-.01.01-.02.01-.02l5.5-5.5c.01-.01.02-.01.03-.02-.64-.44-1.42-.7-2.25-.7-2.21 0-4 1.79-4 4 0 .75.21 1.46.58 2.06.05.06.09.12.13.18zm6.6-4.49c-.01.01-.01.02-.02.03l-5.5 5.5c-.01.01-.02.01-.03.02.64.44 1.41.7 2.25.7 1.46 0 2.73-.78 3.42-1.94.37-.6.58-1.31.58-2.06 0-.84-.26-1.61-.7-2.25z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M22 9v6c0 3.5-2 5-5 5H8.45c.35-.59.55-1.27.55-2 0-2.21-1.79-4-4-4-1.2 0-2.27.53-3 1.36V9c0-3.5 2-5 5-5h10c3 0 5 1.5 5 5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 14.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm6.5.25c-.41 0-.75-.34-.75-.75v-4c0-.41.34-.75.75-.75s.75.34.75.75v4c0 .41-.34.75-.75.75z"
})));